<template>
  <div>
    <div v-if="requestPending">
    </div>
    <div v-else-if="!showError">
      <h2>{{ lang.AR0001 }}</h2>
      <p>{{ lang.AR0002 }}</p>
    </div>
    <div v-else>
      <h2>{{ lang.AR0003 }}</h2>
      <p>{{ lang.AR0004 }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppRegistration",
  props: {},
  data() {
    return {
      requestPending: true,
      showError: false,
      lang: {
        AR0001: "Registration successful!",
        AR0002: "Your data has been successfully registered for the use of Chex. Starting from 2 April 2025, you can download the Chex app from the Apple App Store and Google Play Store.",
        AR0003: "Registration failed!",
        AR0004: "An unexpected error occurred. Please try again or contact our support."
      }
    }
  },
  async mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  
    this.globals.getCurrentUserInfo(this.setRegistration);
  },
  methods: {
    async setRegistration() {
      const urlParams = new URLSearchParams(window.location.search);
      const urlParam_code = urlParams.get('code');

      let body = {
        "userId": this.globals.currentUserInfo.UserId,
        "lang": this.globals.currentLocale,
        "code": urlParam_code
      };

      await $.ajax({
        method: "POST",
        url: `shopper-api/AppRegistration`,
        data: JSON.stringify(body),
        success: (data) => {
          console.log(data);
          if(data.error) {
            throw data.error;
          }
          this.requestPending = false;
        },
        error: (error) => {
          this.requestPending = false;
          console.error("Error on GET in GetRegistrationUrl()", error);
          this.showError = true;
        },
      });
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AppRegistration.vue?8803720a